// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__kVwYx","ranges":"BmiRanges_ranges__3Mfrb"};